import { Platform } from 'react-native';
import structuredClone from '@ungap/structured-clone';

const setupPolyfills = async () => {
  if (Platform.OS === 'web') {
    return;
  }

  try {
    const { polyfillGlobal } = await import(
      'react-native/Libraries/Utilities/PolyfillFunctions'
    );

    const { TextEncoderStream, TextDecoderStream } = await import(
      '@stardazed/streams-text-encoding'
    );

    if (!('structuredClone' in global)) {
      polyfillGlobal('structuredClone', () => structuredClone);
    }

    polyfillGlobal('TextEncoderStream', () => TextEncoderStream);
    polyfillGlobal('TextDecoderStream', () => TextDecoderStream);
  } catch (error) {
    console.error('Failed to setup polyfills:', error);
  }
};

// Start polyfill setup immediately with proper error handling
export const polyfillsReady = setupPolyfills();

export {};

